module.exports = __webpack_public_path__ + "img/xyzscq.2c6103ba.png";